import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";
import projdata from "../../assets/data.json";
import about from "../../assets/about.json";

export default {
  namespaced: true,
  state() {
    return {
      projects: projdata,
      about: about,
    };
  },
  mutations,
  actions,
  getters,
};
